<template>
  <div class="app">
    <DefaultHeader :breadcrumbs="breadcrumbs" />
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <!--<Breadcrumb :list="list"/>-->
        <div class="container-fluid h-100">
          <router-view ref="routerView" @breadcrumbs="updateBreadcrumbs(arguments[0])"></router-view>
        </div>
      </main>
      <!--
      <AppAside fixed>
        <DefaultAside/>
      </AppAside>
      -->
    </div>
    <!--<DefaultFooter/>-->
  </div>
</template>

<script>
import nav from '@/_nav'
import { Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeader from './DefaultHeader'
import DefaultFooter from './DefaultFooter'
import HttpInterceptor from 'vue-core/auth/HttpInterceptor';
import { uuid } from 'core/utils';

export default {
  name: 'DefaultContainer',
  components: {
    AppSidebar,
    AppAside,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultFooter,
    DefaultHeader
  },

  data () {
    return {
      breadcrumbs: null,
    };
  },

  computed: {
    name () {
      return this.$route.name
    },

    /*
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    */
    userInfo() {
      return HttpInterceptor.loggedUser;
    },
    nav() {
      return nav({ t: this.$t.bind(this), userInfo: this.userInfo }).items;
    }
  },
  methods: {
    updateBreadcrumbs(breadcrumbs) {
      console.log('updating breadcrumbs', breadcrumbs);
      this.breadcrumbs = breadcrumbs;
    }
  }
}
</script>
